import React, {Component} from 'react';
import {Col, ControlLabel, Form, FormGroup} from "react-bootstrap";
import {TopSelect} from "../../../../componentsTopsa/selects/TopSelects";
import initialData from "../../../../utilities/initialData/initialData";
import TopDostepnosc from "../../../../componentsTopsa/dostepnosc/TopDostepnosc";
import {TopButtonAction} from "../../../../componentsTopsa/buttons/TopButtons";
import TrasyService from "../../../konfiguracja/trasyConfig/trasy/TrasyService";
import {TopInputDate} from "../../../../componentsTopsa/inputs/TopInputs";
import moment from "moment";
import DateAndTimeFormat from "../../../../utilities/DateAndTimeFormat";

export default class SprzedazMiesiecznychSearchbox extends Component {
    constructor(props) {
        super(props);
        this.state = {
            dataOd: moment(),
            dataDo: moment(),
            trasa: null,
            trasy: [],
            status: null,
            statusy: [
                {value: '-1', label: 'do opłaty'},
                {value: '1', label: 'opłacony'},
            ],
            miejsce:  null,
            miejsca: [
                {value: 'INTERNET', label: 'INTERNET'},
                {value: 'BIURO', label: 'BIURO'},
                {value: 'MOBILE', label: 'MOBILE'},
                {value: 'KIEROWCA', label: 'KIEROWCA'},
                ]
        };
        this.onChangeDataOd = this.onChangeDataOd.bind(this)
        this.onChangeDataDo = this.onChangeDataDo.bind(this)
        this.onChangeTrasa = this.onChangeTrasa.bind(this)
        this.onChangeStatus = this.onChangeStatus.bind(this)
        this.onChangeMiejsce = this.onChangeMiejsce.bind(this)
        this.onClickSzukaj = this.onClickSzukaj.bind(this)
    }


    componentDidMount() {
        this.pobierzTrasy();

        let currentmiesiac = (new Date().toJSON().substr(5, 2))
        if (Boolean(currentmiesiac)) {
            this.setState({
                miesiac: initialData.returnArrayMiesiace().find(m => m.value == parseInt(currentmiesiac))
            })
        }
    }

    pobierzTrasy() {
        TrasyService.getTrasy().then(function (response) {
            this.setState({trasy: response.data.content})
        }.bind(this))
    }

    onChangeDataOd(e) {
        this.setState({dataOd: e})
    }

    onChangeDataDo(e) {
        this.setState({dataDo: e})
    }

    onChangeTrasa(e) {
        this.setState({trasa: e})
    }

    onChangeStatus(e) {
        this.setState({status: e})
    }

    onChangeMiejsce(e) {
        this.setState({miejsce: e})
    }

    onClickSzukaj() {
        if (DateAndTimeFormat.formatYYYYMMDD(this.state.dataOd) > DateAndTimeFormat.formatYYYYMMDD(this.state.dataDo)) {
            alert('Data do nie może być wcześniejsza od daty od')
        } else {
            let data = {
                "idTr": Boolean(this.state.trasa) ? this.state.trasa.idTr : null,
                "nazTr": Boolean(this.state.trasa) ? this.state.trasa.nazTr : null,
                "dataDo": DateAndTimeFormat.formatYYYYMMDD(this.state.dataDo),
                "dataOd": DateAndTimeFormat.formatYYYYMMDD(this.state.dataOd),
                "statBil": Boolean(this.state.status) ? this.state.status.value : null,
                "statusNazwa": Boolean(this.state.status) ? this.state.status.label : null,
                "sprzedazMiejsce": Boolean(this.state.miejsce) ? this.state.miejsce.value : null,
            }
            this.props.handleClickSzukaj(data)
        }
    }

    formatTrasaSelect(option) {
        return <div><span className={'label label-ebus-primary'}>{option.kodTrasy}</span> {option.nazTr} <TopDostepnosc
            wartoscWarunek={0}
            wartosc={option.status}
            czyMarginesLewy={true}/>
        </div>
    }

    render() {

        return (
            <div>
                <Form>
                    <FormGroup>
                        <Col xs={2}>
                            <ControlLabel>Data od <span className={'req'}>*</span></ControlLabel>
                            <TopInputDate onChange={this.onChangeDataOd} value={this.state.dataOd}/>
                        </Col>
                        <Col xs={2}>
                            <ControlLabel>Data do <span className={'req'}>*</span></ControlLabel>
                            <TopInputDate onChange={this.onChangeDataDo} value={this.state.dataDo}/>
                        </Col>
                        <Col xs={3}>
                            <ControlLabel>Trasa</ControlLabel>
                            <TopSelect onChange={this.onChangeTrasa} value={this.state.trasa} options={this.state.trasy}
                                       labelKey={'nazTr'}
                                       valueKey={'idTr'} valueRenderer={this.formatTrasaSelect}
                                       optionRenderer={this.formatTrasaSelect}/>
                        </Col>
                        <Col xs={1}>
                            <ControlLabel>Status</ControlLabel>
                            <TopSelect onChange={this.onChangeStatus} value={this.state.status}
                                       options={this.state.statusy}/>
                        </Col>
                        <Col xs={2}>
                            <ControlLabel>Miejsce sprzedaży</ControlLabel>
                            <TopSelect onChange={this.onChangeMiejsce} value={this.state.miejsce}
                                       options={this.state.miejsca}/>
                        </Col>
                        <Col xs={2}>
                            <div className={'add-label-margin'}></div>
                            <TopButtonAction text={'Szukaj'} iconType={'fa fa-search'} btnColor={'primary'}
                                             btnSize={'md'} onClick={this.onClickSzukaj}/>
                        </Col>
                        <Col xs={2} lg={12}>
                            <small><span className={'req'}>*</span>Data wprowadzenia do systemu</small>
                        </Col>
                    </FormGroup>
                </Form>
            </div>
        );
    }
}




// WEBPACK FOOTER //
// ./src/modules/raporty/SprzedazMiesiecznych/components/SprzedazMiesiecznychSearchbox.js